document.addEventListener('DOMContentLoaded', function () {
    var filterContainer = document.querySelector('.product-cases__filter');
    var filterItems = filterContainer
        ? Array.prototype.slice.call(filterContainer.querySelectorAll('.filter-item'))
        : [];
    var slides = Array.prototype.slice.call(document.querySelectorAll('.product-cases .customer-cases__slide'));

    function matchesSlide(slide, handle) {
        var sh = slide.getAttribute('data-case-group-handle');
        return handle && sh === handle;
    }

    function activate(handle) {
        slides.forEach(function (slide) {
            slide.classList.toggle('is-active', matchesSlide(slide, handle));
        });
        filterItems.forEach(function (item) {
            var ih = item.getAttribute('data-case-group-handle');
            var active = handle && ih === handle;
            item.classList.toggle('filter-item--active', active);
        });
    }

    // 默认激活第一个能匹配到内容的项
    if (filterItems.length > 0 && slides.length > 0) {
        var firstHandle = filterItems[0].getAttribute('data-case-group-handle');
        var idx = 0;
        while (
            idx < filterItems.length &&
            !slides.some(function (s) {
                return matchesSlide(s, firstHandle);
            })
        ) {
            idx++;
            if (idx < filterItems.length) {
                firstHandle = filterItems[idx].getAttribute('data-case-group-handle');
            }
        }
        if (idx < filterItems.length) {
            activate(firstHandle);
        }
    }

    if (filterContainer) {
        filterContainer.addEventListener('click', function (e) {
            var item = e.target.closest && e.target.closest('.filter-item');
            if (!item) return;
            var handle = item.getAttribute('data-case-group-handle');
            e.preventDefault();
            activate(handle);
        });
    } else {
        if (slides && slides.length > 0) {
            slides[0].classList.add('is-active');
        }
    }
});